const getVisibleFilterByTab = (selectedTab) => {
  let filters = { isBrandFilterVisible: true, isStatusVisible: true };

  switch (selectedTab) {
    case 'talkingPoint':
      filters = { ...filters, isDraftStatusVisible: true };
      break;
    case 'giveaway':
      filters = { ...filters, isPromoSearchVisible: true };
      break;

    default:
      break;
  }

  return filters;
};

export default getVisibleFilterByTab;
